import posthog from "posthog-js";
import type { AuthFitnessCenterDO, AuthStaffDO } from "@/types/auth";

const POSTHOG_APP = "b2b_portal";
const POSTHOG_PLATFORM = "web";

let isInitialized = false;

const hasPostHogConfig = () =>
  Boolean(import.meta.env.VITE_POSTHOG_KEY) &&
  Boolean(import.meta.env.VITE_POSTHOG_HOST);

export const isAnalyticsEnabled = () => import.meta.env.PROD && hasPostHogConfig();

const registerPortalProperties = () => {
  posthog.register({
    app: POSTHOG_APP,
    platform: POSTHOG_PLATFORM,
  });
};

export const initAnalytics = () => {
  if (!isAnalyticsEnabled() || isInitialized) {
    return;
  }

  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: "identified_only",
    capture_pageview: "history_change",
    autocapture: false,
    disable_session_recording: true,
  });

  registerPortalProperties();
  isInitialized = true;
};

export const identifyPortalSession = (
  staff: AuthStaffDO,
  gym: AuthFitnessCenterDO
) => {
  if (!isAnalyticsEnabled()) {
    return;
  }

  const parentCenterId = gym.parentCenterId ?? null;
  const isBranch = Boolean(parentCenterId);

  posthog.identify(staff._id, {
    staff_role: staff.role,
    is_owner: staff.isOwner,
  });

  posthog.group("gym", gym._id, {
    name: gym.name,
    parent_center_id: parentCenterId,
    is_branch: isBranch,
  });

  posthog.register({
    active_gym_id: gym._id,
    parent_center_id: parentCenterId,
    is_branch: isBranch,
    staff_role: staff.role,
    is_owner: staff.isOwner,
  });
};

export const resetPortalAnalytics = () => {
  if (!isAnalyticsEnabled()) {
    return;
  }

  posthog.reset();
  registerPortalProperties();
};
